import { CheckCircleFilled } from "@ant-design/icons";
import { Button, message } from "antd";
import Container from "components/Desktop/Container";
import Header from "components/Desktop/Header";
import MobileContainer from "components/Mobile/Container";
import MobileHeader from "components/Mobile/Header";
import { E_USER_TIER, IS_BREAKPOINT_DESKTOP } from "constants/common";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";
import qrNarin from "src/assets/qr_narin.png";
import qrNarinWholesale from "src/assets/qr_narin_wholesale.png";

const RegisterSuccessPage = () => {
  const navigation = useNavigate();
  const location = useLocation();
  const isDesktop = useMediaQuery({
    query: IS_BREAKPOINT_DESKTOP,
  });

  const userTierId: number | undefined = location.state?.userTierId;
  // Same rule as Footer: wholesale tiers use @narinonline, retail uses @narinch
  const isNarinOnline =
    userTierId !== undefined &&
    userTierId >= E_USER_TIER.GROCERY &&
    userTierId <= E_USER_TIER.PHARMACY;
  const qrImage = isNarinOnline ? qrNarinWholesale : qrNarin;
  const lineText = isNarinOnline ? "@narinonline" : "@narinch";
  const lineLink = isNarinOnline
    ? "https://lin.ee/BWu49Qe"
    : "https://lin.ee/fNyEukl";

  const handleCopyLineId = async () => {
    await navigator.clipboard.writeText(lineText);
    message.success("คัดลอกแล้ว");
  };

  const content = (
    <main className="min-h-[700px] bg-[#F7F4FA] pt-8 p-4 flex justify-center">
      <div className="w-full max-w-[800px] flex flex-col items-center gap-4 pt-8">
        <div className="flex gap-2">
          <CheckCircleFilled className="text-[24px] text-[#00AA86]" />
          <div className="text-2xl font-semibold text-center">
            สมัครสมาชิกเรียบร้อยแล้ว
          </div>
        </div>
        <div className="text-center">
          บัญชีของท่านพร้อมใช้งาน · สิทธิ์ราคาสมาชิกอยู่ระหว่างตรวจสอบ
        </div>
        <div className="text-center text-lg font-semibold mt-2">
          อีก 1 ขั้นตอน — แอดไลน์ร้าน แล้วทักมาได้เลย
        </div>
        <div className="text-center">
          ทีมงานจะยืนยันข้อมูลและแจ้งรหัสสมาชิกให้ทางไลน์
          และทุกออเดอร์ที่สั่งผ่านเว็บ
        </div>
        <div className="text-center">
          เราจะเช็กของให้ครบ เสนอตัวแทนถ้าของขาด แล้วแจ้งยอดกับค่าจัดส่ง
        </div>
        <img
          src={qrImage}
          alt="LINE QR Code"
          width={260}
          height={260}
          className="max-w-full"
        />
        <div
          className="text-center text-xl font-semibold cursor-pointer"
          onClick={handleCopyLineId}
        >
          {lineText}{" "}
          <span className="text-sm font-normal">(แตะเพื่อคัดลอก)</span>
        </div>
        <Button
          type="primary"
          size="large"
          className="w-[250px] mt-2"
          href={lineLink}
          target="_blank"
        >
          แอดไลน์แล้วทักเลย
        </Button>
        <div className="text-center mt-2">
          แอดแล้วพิมพ์ "ชื่อร้าน + เบอร์ที่ใช้สมัคร" มาได้เลยค่ะ
        </div>
        <div className="text-center">
          ทีมงานตอบกลับ จันทร์-เสาร์ 08.00-18.00 น. ปิดวันอาทิตย์
        </div>
        <Button
          type="link"
          className="mt-2"
          onClick={() => navigation("/authen?tab=login")}
        >
          ตกลง
        </Button>
      </div>
    </main>
  );

  if (isDesktop) {
    return (
      <div>
        <Container>
          <Header />
        </Container>
        <Container>{content}</Container>
      </div>
    );
  }

  return (
    <div>
      <MobileContainer>
        <MobileHeader />
        {content}
      </MobileContainer>
    </div>
  );
};
export default RegisterSuccessPage;
